<template>
  <div class="chart-wrapper">
    <PieChartComponent 
      :chart-data="chartData" 
      :chart-options="mergedOptions" 
    />
  </div>
</template>

<script>
import { Pie } from 'vue-chartjs'
import { 
  Chart as ChartJS, 
  Title, 
  Tooltip, 
  Legend, 
  ArcElement 
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement)

export default {
  name: 'PieChart',
  components: { 
    PieChartComponent: Pie  // ✅ Renombrar para evitar conflictos
  },
  props: {
    labels: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    backgroundColor: {
      type: Array,
      default: () => ['#6b20c1', '#ff5e20', '#ffc107', '#28a745', '#dc3545', '#17a2b8']
    },
    borderColor: {
      type: Array,
      default: () => ['#fff', '#fff', '#fff', '#fff', '#fff', '#fff']
    },
    borderWidth: {
      type: Number,
      default: 2
    },
    title: {
      type: String,
      default: ''
    },
    chartOptions: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    chartData() {
      return {
        labels: this.labels,
        datasets: [{
          backgroundColor: this.backgroundColor,
          borderColor: this.borderColor,
          borderWidth: this.borderWidth,
          data: this.data
        }]
      }
    },
    mergedOptions() {
      const defaultOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'bottom'
          },
          title: {
            display: this.title !== '',
            text: this.title
          }
        }
      }
      
      return this.deepMerge(defaultOptions, this.chartOptions)
    }
  },
  methods: {
    deepMerge(target, source) {
      const output = Object.assign({}, target)
      if (this.isObject(target) && this.isObject(source)) {
        Object.keys(source).forEach(key => {
          if (this.isObject(source[key])) {
            if (!(key in target)) {
              Object.assign(output, { [key]: source[key] })
            } else {
              output[key] = this.deepMerge(target[key], source[key])
            }
          } else {
            Object.assign(output, { [key]: source[key] })
          }
        })
      }
      return output
    },
    isObject(item) {
      return item && typeof item === 'object' && !Array.isArray(item)
    }
  }
}
</script>

<style scoped>
.chart-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>